import footer from './footer/footerLocalization.json';
import formErrors from './formErrors/formErrorsLocalization.json';

export const footerMessages = footer;
export const errorsMessage = formErrors;
